/* Mobile Filter — turn the in-drawer "Back" into "Close"
   - Intercepts clicks on #filter-drawer .filter-form__group-panel-toggle
   - Tries to click the theme's own close control; if none, hides the drawer as a fallback
   - Optionally replaces the arrow icon with an × for visual clarity
*/
(function () {
  // Intercept the back button (capture phase so we beat theme handlers)
  document.addEventListener('click', function (e) {
    const btn = e.target && e.target.closest('#filter-drawer .filter-form__group-panel-toggle');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    const drawer = document.querySelector('#filter-drawer');
    if (!drawer) return;

    // 1) Prefer the theme's native close control
    let closer = drawer.querySelector(
      '[data-close], [data-action="close"], [data-filter-drawer-close], ' +
      '.drawer__close, .filter-drawer__close, ' +
      'button[aria-label="Close"]:not(.filter-form__group-panel-toggle), .icon-close'
    );
    if (closer) { try { closer.click(); return; } catch (_) {} }

    // 2) Try overlay/wash
    let wash = drawer.querySelector('.filter-drawer__wash, [data-filter-drawer-wash]');
    if (wash) { try { wash.click(); return; } catch (_) {} }

    // 3) Hard fallback: hide, then restore
    drawer.style.display = 'none';
    setTimeout(() => drawer.style.removeProperty('display'), 350);
  }, true);

  // Optional: swap the arrow to an × so users see it's a close
  const mo = new MutationObserver(() => {
    const drawer = document.querySelector('#filter-drawer');
    if (!drawer) return;
    const btn = drawer.querySelector('.filter-form__group-panel-toggle');
    if (btn && !btn.dataset._btcx) {
      btn.dataset._btcx = '1';
      btn.setAttribute('aria-label', 'Close');
      const iconHost = btn.querySelector('.icon-button__icon, .icon, .icon-button');
      if (iconHost) iconHost.innerHTML = '<span style="font-size:40px;line-height:1;display:inline-block">×</span>';
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
